import { useCallback, useState } from "react";

export function useShare() {
  const [status, setStatus] = useState<"idle" | "copied" | "failed">("idle");

  const share = useCallback(async (title: string, text: string, url: string) => {
    try {
      if (typeof navigator !== "undefined" && navigator.share) {
        await navigator.share({ title, text, url });
        setStatus("idle");
        return;
      }
      if (typeof navigator !== "undefined" && navigator.clipboard) {
        await navigator.clipboard.writeText(url);
        setStatus("copied");
        window.setTimeout(() => setStatus("idle"), 2400);
        return;
      }
      setStatus("failed");
      window.setTimeout(() => setStatus("idle"), 2400);
    } catch {
      setStatus("idle");
    }
  }, []);

  return { share, status };
}